import { serviceName } from '../resources/serviceConstants';
import { GET_USER_ROLES, ROLE_MAP_LIST } from '../resources/endPoint';

export const roleMapList = (token) => {
  // API call to fetch user role_map list
  return {
    url: ROLE_MAP_LIST,
    method: 'get',
    headers: { 'content-type': 'application/json', authorization: token },
    authRequired: false,
    csrfToken: true,
    service: serviceName.ROLES_MS,
  };
};

export const userMapRole = (data, token) => {
  return {
    url: GET_USER_ROLES,
    method: 'post',
    headers: { 'content-type': 'application/json', authorization: token },
    authRequired: false,
    csrfToken: true,
    payload: data,
    service: serviceName.USER_ROLES_MS,
  };
};

export const userEditMapRole = (data, token) => {
  return {
    url: GET_USER_ROLES,
    method: 'patch',
    headers: { 'content-type': 'application/json', authorization: token },
    authRequired: false,
    csrfToken: true,
    payload: data,
    service: serviceName.USER_ROLES_MS,
  };
};

export const userDeleteMapRole = (ids, token) => {
  return {
    url: `${GET_USER_ROLES}?ids=${Array.isArray(ids) ? ids.join(',') : ids}`,
    method: 'delete',
    headers: { 'content-type': 'application/json', authorization: token },
    authRequired: false,
    csrfToken: true,
    service: serviceName.USER_ROLES_MS,
  };
};
